import { Tabs, TabsList, TabsTrigger } from '@/components/ui/tabs';

interface SupportFiltersProps {
  value: string;
  onChange: (value: string) => void;
}

export const SupportFilters = ({ value, onChange }: SupportFiltersProps) => {
  return (
    <Tabs value={value} onValueChange={onChange} className="w-full">
      <TabsList className="w-full grid grid-cols-3 bg-black/40 border-white/20">
        <TabsTrigger 
          value="all"
          className="data-[state=active]:bg-luxury-pinkBright data-[state=active]:text-white text-white/60"
        >
          Todos
        </TabsTrigger>
        <TabsTrigger 
          value="open"
          className="data-[state=active]:bg-luxury-pinkBright data-[state=active]:text-white text-white/60"
        >
          Abertos
        </TabsTrigger>
        <TabsTrigger 
          value="resolved"
          className="data-[state=active]:bg-luxury-pinkBright data-[state=active]:text-white text-white/60"
        >
          Resolvidos
        </TabsTrigger>
      </TabsList>
    </Tabs>
  );
};
